<template>
  <div class="tw-grid tw-grid-flow-col tw-grid-cols-1 tw-grid-rows-4 sm:tw-grid-cols-2 sm:tw-grid-rows-2 tw-shadow lg:tw-grid-cols-4 lg:tw-grid-rows-1 tw-gap-3 tw-bg-infinity-background-emphasized tw-p-4 tw-rounded-md">
    <!-- Sound Types  -->
    <div>
      <label class="tw-text-infinity-secondary-text" for="types">Types</label>
      <base-multiselect
          id="types"
          multiple
          placeholder="Select Types"
          :limit="0"
          :limitText="(count) => `${count} Types`"
          :loading="enums.types.loading"
          trackBy="name"
          :customLabel="getOptionLabel"
          v-model="selected.types"
          :options="enums.types.list || []" />
    </div>

    <!-- Tags  -->
    <!--
        <div>
          <label class="tw-text-infinity-secondary-text" for="tags">Tags</label>
          <base-multiselect
              id="tags"
              multiple
              placeholder="Select Tags"
              :limit="0"
              :internal-search="false"
              preserve-search
              :clear-on-select="false"
              :hide-options="!enums.tags.list"
              :limitText="(count) => `${count} Tags`"
              trackBy="name"
              @search-change="onTagSearch"
              :customLabel="getOptionLabel"
              :loading="enums.tags.loading"
              v-model="selected.tags"
              :options="enums.tags.list || []">
          </base-multiselect>
        </div>
    -->

    <!-- Instruments  -->
    <div>
      <label class="tw-text-infinity-secondary-text" for="instruments">Instruments</label>
      <base-multiselect
          id="instruments"
          multiple
          placeholder="Select Instruments"
          :limit="0"
          :limitText="(count) => `${count} Instruments`"
          trackBy="name"
          :customLabel="getOptionLabel"
          :loading="enums.instruments.loading"
          v-model="selected.instruments"
          :options="enums.instruments.list || []" />
    </div>

    <!-- Date Added  -->
    <div>
      <label class="tw-text-infinity-secondary-text" for="added">Added</label>
      <base-multiselect
          id="added"
          :loading="enums.added.loading"
          v-model="selected.added"
          preselectFirst
          :allow-empty="false"
          :customLabel="getOptionLabel"
          :options="enums.added.list || []" />
    </div>

    <!-- Order  -->
    <div>
      <label class="tw-text-infinity-secondary-text" for="order">Sort By</label>
      <base-multiselect
          id="order"
          :loading="enums.sortBy.loading"
          v-model="selected.sortBy"
          preselectFirst
          :allow-empty="false"
          :customLabel="getOptionLabel"
          :options="enums.sortBy.list || []" />
    </div>
  </div>
</template>
<script>
import BaseMultiselect from "../../base/base-multiselect";
import { defineComponent, computed } from "@vue/composition-api";
import { useDebounceFn } from "@vueuse/core";
import { useSoundkitsFilterContext } from "./soundkits-filter";

export default defineComponent({
  components: { BaseMultiselect },
  setup(_, { root }) {
    const enums = computed(() => root.$store.state['soundkits'])
    const onTagSearch = useDebounceFn((query) => {
      root.$store.dispatch('soundkits/loadTags', query)
    }, 300)
    const getOptionLabel = (option) => option.name
    const limitText = (count) => `+${count}`
    const state = useSoundkitsFilterContext()
    const selected = computed(() => state.selected)

    root.$store.dispatch('soundkits/loadTypes')
    root.$store.dispatch('soundkits/loadInstruments')

    return {
      selected,
      enums,
      onTagSearch,
      limitText,
      getOptionLabel
    }
  },
})
</script>
